<template>
	<div class='applyFor'>
		<div
			class="block"
			v-loading="loading"
		>
			<el-date-picker
				ref="picker"
				@change="onChange"
				:clearable="false"
				v-model="value"
				value-format="yyyy-MM"
				type="month"
				placeholder="选择月"
			>
			</el-date-picker>

			<div class="conter_box">
				<div
					:class="['record', !i ? 'bor_top' : '']"
					v-for="(el,i) in dataList"
					:key="i"
				>
					<div
						class=""
						style="display: flex;align-items: center;"
					>
						<img
							:src="$store.state.onlineBasePath + 'group1/M00/12/52/L2rchmSdQHuAbzNkAAAJA2RA4hA578.png'"
							mode=""
						/>
						<div class="">
							<div
								class="goods_name"
								v-if="el.alipayAccount"
							>
								账号：{{el.alipayAccount}}(支付宝)
								<div :class="['label_box',el.status === 2 ? 'shibai' : '']">
									{{el.status === 0 ? '申请中' : el.status === 1 ? '已提现' : '审核失败'}}
								</div>
							</div>
							<div
								class="goods_name"
								v-else
							>
								微信
								<div :class="['label_box',el.status === 1 ? 'success_box' : el.status === 2 ? 'shibai' : '']">
									{{el.status === 0 ? '申请中' : el.status === 1 ? '已提现' : '审核失败'}}
								</div>
							</div>
							<div class="goods_time">{{el.createTime}}</div>
						</div>
					</div>
					<div class="price_box">
						<span style="margin-right: 10rpx;">{{el.amount}}</span>
					</div>
				</div>
			</div>

			<div
				class="kong"
				v-if="dataList.length == 0"
			>
				<img
					:src="$store.state.wqurl + 'all_page_nullTowImg.png'"
					alt=""
				>

				暂无数据
			</div>
		</div>
		<div class="pagination">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page.sync="page"
				layout="prev, pager, next, jumper"
				:total="total"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { pageWithdrawCash } from "@/api/professionServer";
export default {
  name: "applyFor",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      value: new Date(),
      dataList: [],
      page: 1,
      total: 0,
      loading: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onChange() {
      this.pageWithdrawCash();
    },

    handleCurrentChange(val) {
      this.page = val;
      this.dataList = [];
      this.pageWithdrawCash(false);
    },

    async pageWithdrawCash(reset = true) {
      try {
        this.loading = true;
        if (reset) {
          this.page = 1;
          this.dataList = [];
        }

        const data = {
          page: this.page,
          limit: 15,
          yearMonth: this.value,
        };

        const res = await pageWithdrawCash(data);
        this.loading = false;
        if (res.code !== 200) return;
        this.dataList = res.data.data;
        this.total = res.data.total;
      } catch (error) {
        this.loading = false;
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.pageWithdrawCash();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.applyFor {
  height: 100%;
  .block {
    height: calc(100% - 40px);
    overflow: auto;

    .conter_box {
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;

      .record {
        width: 100%;
        padding: 20px 0;
        border-bottom: 1px #f0f0f0 solid;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
          width: 40px;
          margin-right: 18px;
        }
        .goods_name {
          display: flex;
          align-items: center;
          font-size: 15px;
          color: #333333;
          margin-bottom: 10px;
        }

        .label_box {
          padding: 4px 8px;
          background-color: #00bf6f;
          color: #fff;
          font-size: 12px;
          border-radius: 5px;
          margin-left: 10px;
        }

        .shibai {
          background-color: #e70003;
        }

        .success_box {
          background-color: #9e9e9e;
        }

        .goods_time {
          font-size: 12px;
          color: #999999;
        }

        .price_box {
          font-size: 17px;
          font-weight: bold;
          color: #333333;
          display: flex;
          align-items: center;
        }
      }

      .bor_top {
        border-top: 1px #f0f0f0 solid;
      }
    }
  }

  .kong {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 14px;
    gap: 10px;
    color: #a6a9b1;
    justify-content: center;
    height: 80%;
    width: 100%;

    img {
      width: 110px;
    }
  }

  .pagination {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
  }

  ::v-deep .el-input__inner {
    cursor: pointer;
    border-color: transparent !important;
  }
}
</style>